// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

const isLocalhost = Boolean(
	window.location.hostname === "localhost" ||
		// [::1] is the IPv6 localhost address.
		window.location.hostname === "[::1]" ||
		// 127.0.0.0/8 are considered localhost for IPv4.
		window.location.hostname.match(
			/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
		)
);

export function register(config) {
	// En producción, registramos el service-worker.js de Create React App
	// En desarrollo, o si no queremos PWA, no hacemos nada
	if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
		// La URL constructor está disponible en todos los navegadores que soportan SW.
		const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
		if (publicUrl.origin !== window.location.origin) {
			// Nuestro service worker no funcionará si PUBLIC_URL está en un origen diferente
			// al que se sirve nuestra página. Esto podría ocurrir si se usa una CDN
			// para servir activos; ver https://github.com/facebook/create-react-app/issues/2374
			return;
		}

		window.addEventListener("load", () => {
			// Usamos service-worker.js para funcionalidad PWA estándar
			// Nota: esto es diferente de sw.js que usamos para notificaciones
			const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

			if (isLocalhost) {
				// Esto se ejecuta en localhost. Verificamos si existe un service worker.
				checkValidServiceWorker(swUrl, config);

				// Agregamos registro adicional para desarrolladores
				navigator.serviceWorker.ready.then(() => {
					console.log(
						"Esta aplicación web se sirve primero desde caché por un " +
							"service worker. Para aprender más, visita https://cra.link/PWA"
					);
				});
			} else {
				// No es localhost. Simplemente registramos el service worker
				registerValidSW(swUrl, config);
			}
		});
	}
}

function registerValidSW(swUrl, config) {
	navigator.serviceWorker
		.register(swUrl)
		.then((registration) => {
			registration.onupdatefound = () => {
				const installingWorker = registration.installing;
				if (installingWorker == null) {
					return;
				}
				installingWorker.onstatechange = () => {
					if (installingWorker.state === "installed") {
						if (navigator.serviceWorker.controller) {
							// En este punto, el contenido precargado actualizado se ha obtenido,
							// pero el worker anterior seguirá sirviendo el contenido antiguo
							// hasta que todas las pestañas del cliente estén cerradas.
							console.log(
								"Nuevo contenido disponible y se utilizará cuando " +
									"todas las pestañas de esta página estén cerradas. Ver https://cra.link/PWA."
							);

							// Ejecutar callback
							if (config && config.onUpdate) {
								config.onUpdate(registration);
							}
						} else {
							// En este punto, todo ha sido precargado.
							// Es el momento perfecto para mostrar un mensaje
							// "El contenido está en caché para uso sin conexión".
							console.log("Contenido en caché para uso sin conexión.");

							// Ejecutar callback
							if (config && config.onSuccess) {
								config.onSuccess(registration);
							}
						}
					}
				};
			};
		})
		.catch((error) => {
			console.error("Error durante el registro del service worker:", error);
		});
}

function checkValidServiceWorker(swUrl, config) {
	// Verificamos si se puede encontrar el service worker. Si no, recargamos la página.
	fetch(swUrl, {
		headers: { "Service-Worker": "script" },
	})
		.then((response) => {
			// Aseguramos que el service worker existe y que realmente estamos obteniendo un archivo JS.
			const contentType = response.headers.get("content-type");
			if (
				response.status === 404 ||
				(contentType != null && contentType.indexOf("javascript") === -1)
			) {
				// No se encontró el service worker. Probablemente sea una aplicación diferente. Recargamos la página.
				navigator.serviceWorker.ready.then((registration) => {
					registration.unregister().then(() => {
						window.location.reload();
					});
				});
			} else {
				// Service worker encontrado. Procedemos normalmente.
				registerValidSW(swUrl, config);
			}
		})
		.catch(() => {
			console.log(
				"No se encontró conexión a Internet. La aplicación se ejecuta en modo sin conexión."
			);
		});
}

export function unregister() {
	if ("serviceWorker" in navigator) {
		navigator.serviceWorker.ready
			.then((registration) => {
				registration.unregister();
			})
			.catch((error) => {
				console.error(error.message);
			});
	}
}

// Función adicional para verificar si hay una suscripción existente
export async function checkExistingSubscription() {
	if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
		return null;
	}

	try {
		const registration = await navigator.serviceWorker.ready;
		const subscription = await registration.pushManager.getSubscription();
		return subscription;
	} catch (err) {
		console.error("Error al verificar suscripción existente:", err);
		return null;
	}
}
